<template>
    <div :style="{ ...getStyleNoData() }">
        <div v-if="icon">
            <i v-if="icon && icon.includes('fas')" :class="['fa-3x', 'text-muted', icon]"></i>
            <img v-else-if="icon && icon.includes('assets')" :src="icon" alt="logo" />
        </div>
        <div :style="{ ...getStyleNoDataTextTitle() }">{{ title }}</div>
        <div v-if="subtitle != null" :style="{ ...getStyleNoDataTextSubTitle() }">
            {{ subtitle }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: () => {
                return null
            }
        },
        subtitle: {
            type: String,
            default: () => {
                return null
            }
        },
        icon: {
            type: String,
            default: () => {
                return null
            }
        },
        fontColor: {
            type: [String, Number],
            default: "#6c757d"

        },
        fontSize: {
            type: [String, Number],
            default: "20"
        },
        paddingSize: {
            type: [String, Number],
            default: "2"

        }
    },
    computed: {

    },
    methods: {
        //Preparato per diversi tag da utilizzare per le icone
        getIconClass() {
            if (!this.icon) return "";

            if (this.icon.includes("fas")) {
                return `<i class="${this.icon} fa-3x text-muted mb-3"></i>`;
            }

            if (this.icon.includes("mdi")) {
                return `<i class="${this.icon} mdi-36px text-muted mb-3"></i>`;
            }

            return "";
        },

        getStyleNoData() {
            return {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
                textAlign: "center",
                color: "rgb(166, 166, 166)",
                backgroundColor: "rgb(248, 248, 248)",
                borderRadius: "15px",
                border: "2px dashed #c5c5c5",
                paddingTop: this.paddingSize + "rem",
                paddingBottom: this.paddingSize + "rem",
                marginBottom: "2%",
                marginLeft: "7%",
                marginRight: "7%",
                marginTop: "2%"
            }
        },
        getStyleNoDataTextTitle() {
            return {
                fontSize: this.fontSize + "px",
                fontWeight: 800,
                letterSpacing: "-0.02em",
                marginBottom: "8px",
            }
        },
        getStyleNoDataTextSubTitle() {
            return {
                fontSize: this.fontSize - 5 + "px",
                color: "#7e8299",
                fontWeight: 600,
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.kt-empty-icon {
    font-size: 36px;
    color: #d1d3e0;
    margin-bottom: 16px;
}
</style>